export function getRecipeParamsFromUrl(url: string): {
  recipeId?: string;
  sharedToken?: string;
} {
  const queryStringStartIndex = url.indexOf('?');
  if (queryStringStartIndex === -1) return {};

  let queryString = decodeURIComponent(url.slice(queryStringStartIndex + 1));

  // Fix malformed separators like &amp;, &amp%3B, %26amp%3B
  queryString = queryString
    .replace(/&amp;/gi, '&')
    .replace(/&amp%3B/gi, '&')
    .replace(/%26amp%3B/gi, '&');

  const searchParams = new URLSearchParams(queryString);
  const recipeId = searchParams.get('recipe-id') || undefined;
  const sharedToken = searchParams.get('shared_token') || undefined;

  return { recipeId, sharedToken };
}
